












































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'
import { onlyFloat } from '@/utils/common'
import moment from 'moment'

@Component
export default class ModalRegraGarantiaMinimaIncluir extends Vue {
  $refs: {
    formRegraGarantiaMinima: any
  }

  formRegraGarantiaMinimaRule: any = {
    valid: true,
    descricaoRegra: [
      (v: any) => !!v || 'Campo obrigatório',
      (v: any) => (v && v.length <= 100) || 'Máximo de 100 caracteres permitido',
    ],
    valorGarantiaMinima: [(v: any) => !!v || 'Campo obrigatório'],
    prestadorId: [(v: any) => !!v || 'Campo obrigatório'],
    vigenciaInicio: [(v: any) => !!v || 'Campo obrigatório'],
    fontePagadoraIdDestino: [(v: any) => !!v || 'Campo obrigatório'],
    grupoRepasseIdDestino: [(v: any) => !!v || 'Campo obrigatório'],
    profissionalExecutanteIdDestino: [(v: any) => !!v || 'Campo obrigatório'],
    descricaoItemRecebimentoDestino: [
      (v: any) => !!v || 'Campo obrigatório',
      (v: any) => (v && v.length <= 100) || 'Máximo de 100 caracteres permitido',
    ],
  }

  menuInicioVigencia: boolean = false
  menuFimVigencia: boolean = false

  get getRegrasDeCalculoStore() { return getModule(RegrasDeCalculoStore, this.$store) }

  get mode() { return this.getRegrasDeCalculoStore.mode }

  loadAddRegraCalculo: boolean = false
  get loadingAddRegraCalculo() { return this.loadAddRegraCalculo }
  set loadingAddRegraCalculo(value: boolean) { this.loadAddRegraCalculo = value }

  get showModalRegraGarantiaMinima() { return this.getRegrasDeCalculoStore.modal.regraDeCalculoGarantiaMinima }
  set showModalRegraGarantiaMinima(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'regraDeCalculoGarantiaMinima', value }) }

  get gruposRepasse() { return this.getRegrasDeCalculoStore.gruposRepasse }
  get fontesPagadoras() { return this.getRegrasDeCalculoStore.fontesPagadoras }
  get profissionaisExecutantes() { return this.getRegrasDeCalculoStore.profissionaisExecutantes }
  get prestadores() { return this.getRegrasDeCalculoStore.prestadoresRepasse }
  get transacaoFinanceiraList() { return this.getRegrasDeCalculoStore.transacaoFinanceiraList }

  get getMenuInicioVigencia() { return this.menuInicioVigencia }
  set getMenuInicioVigencia(value: boolean) { this.menuInicioVigencia = value }

  get getMenuFimVigencia() { return this.menuFimVigencia }
  set getMenuFimVigencia(value: boolean) { this.menuFimVigencia = value }

  get formattedInicioVigencia() {
    const { vigenciaInicio } = this.getRegrasDeCalculoStore.regraGarantiaMinimaItem
    if (vigenciaInicio) {
      return this.formatDate(vigenciaInicio)
    }
    return ''
  }

  get formattedFimVigencia() {
    const { vigenciaFim } = this.getRegrasDeCalculoStore.regraGarantiaMinimaItem
    if (vigenciaFim) {
      return this.formatDate(vigenciaFim)
    }
    return ''
  }

  updateFimVigencia(date: string) {
    this.getRegrasDeCalculoStore.regraGarantiaMinimaItem.vigenciaFim = date
  }

  updateInicioVigencia(date: string) {
    this.getRegrasDeCalculoStore.regraGarantiaMinimaItem.vigenciaInicio = date
  }

  formatDate(vigencia: any) {
    const date = new Date(vigencia)
    if (!Number.isNaN(date.getTime())) {
      const day = String(date.getUTCDate()).padStart(2, '0')
      const month = String(date.getUTCMonth() + 1).padStart(2, '0')
      const year = date.getUTCFullYear()
      return `${day}/${month}/${year}`
    }
    console.error('Data inválida:', vigencia)
    return ''
  }

  displayDateAndHours(value: any) {
    if (['', null, undefined].includes(value)) return ' - '
    return moment(value).format('DD/MM/YYYY HH:mm')
  }

  onlyFloatUtil(value: number) { return onlyFloat(value) }

  async addGarantiaMinima() {
    this.loadingAddRegraCalculo = true
    if (!this.$refs.formRegraGarantiaMinima.validate()) {
      this.loadingAddRegraCalculo = false
      return
    }
    const request = await this.getRegrasDeCalculoStore.addGarantiaMinima()
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingAddRegraCalculo = false
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Procedimento incluído com sucesso. ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })
    this.loadingAddRegraCalculo = false
    this.getRegrasDeCalculoStore.setMode('EDIT')
    this.getRegrasDeCalculoStore.setModeModalGarantiaMinima('EDIT')
  }

  @Watch('showModalRegraGarantiaMinima')
  onChangeShowModalAddRegraCalculoOperadora(value: boolean) {
    if (!value) {
      this.getRegrasDeCalculoStore.clearRegraGarantiaMinimaItem()
      this.getRegrasDeCalculoStore.setModeModalGarantiaMinima('CREATE')
      this.$refs.formRegraGarantiaMinima.resetValidation()
    }
  }

  get centroDeCustoList() {
    return this.getRegrasDeCalculoStore.centroDeCusto
  }

  async mounted() {
    await this.getRegrasDeCalculoStore.getGruposRepasse()
    await this.getRegrasDeCalculoStore.getTransacaoFinanceira()
    await this.getRegrasDeCalculoStore.getCentroDeCusto()
  }
}
